export const getPlayaOrFirstName = (registration) =>
  registration.formAnswers?.[process.env.REACT_APP_PLAYA_NAME_CUSTOM_FIELD_KEY] ||
  registration.user?.firstName;
